import { render, staticRenderFns } from "./ChromeWebStore.vue?vue&type=template&id=39c81b86&scoped=true"
import script from "./ChromeWebStore.vue?vue&type=script&lang=js"
export * from "./ChromeWebStore.vue?vue&type=script&lang=js"
import style0 from "./ChromeWebStore.vue?vue&type=style&index=0&id=39c81b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c81b86",
  null
  
)

export default component.exports